<script setup lang="ts">
import type { Product } from '~/config'

interface Props {
  product: Product
  formLinks: string
}

defineProps<Props>()
</script>

<template>
  <div class="flex flex-col gap-4">
    <div>
      <TitleComponent
        v-if="product?.tagline"
        :text="product?.tagline.toUpperCase()"
        type="subtitle"
      />
      <div class="text-sm md:text-base">
        {{ product?.description }}
      </div>
    </div>
    <PvButton
      class="w-full"
      as="a"
      @click="navigateTo(formLinks, { external: true })"
    >
      <span class="py-2 text-xl font-bold uppercase md:text-2xl">Comprar ahora</span>
    </PvButton>
    <GridComponent :cols="4">
      <template
        v-for="(h, i) in product?.highlights"
        :key="i"
      >
        <CardComponent bg="light">
          <template #header>
            <span class="text-xs font-bold uppercase text-center">{{ h.title }}</span>
          </template>
          <div class="flex w-full justify-center">
            <ImageComponent
              :src="`/siteAssets/img|product-traits/${h.artwork}`"
              :alt="h.title"
              class="md:h-18 h-16"
            />
          </div>
          <div class="text-sm text-center">
            {{ h.description }}
          </div>
        </CardComponent>
      </template>
    </GridComponent>
  </div>
</template>
